import React from 'react';

interface Props {
  message: string;
  details?: string;
  onClose: () => void;
}

export function ErrorAlert({ message, details, onClose }: Props) {
  return (
    <div className="admin-modal-overlay" onClick={onClose}>
      <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal-header">
          <h3 className="admin-modal-title" style={{ color: 'var(--admin-error)' }}>
            Error
          </h3>
        </div>
        <div className="admin-modal-body">
          <p style={{ fontWeight: 500, marginBottom: details ? '8px' : 0 }}>{message}</p>
          {details && (
            <p style={{ color: 'var(--admin-fg-muted)', fontSize: 'var(--text-sm)' }}>
              {details}
            </p>
          )}
        </div>
        <div className="admin-modal-footer">
          <button className="admin-btn admin-btn-secondary" onClick={onClose}>
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
}
